import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { CodaltComponent } from 'src/app/codalt.component';
import { AuthService } from 'src/app/services/auth/auth.service';

@Component({
    selector: 'app-login-as-user',
    templateUrl: './login-as-user.component.html',
    standalone: false,
})
export class LoginAsUserComponent extends CodaltComponent implements OnInit {
    constructor(
        private authService: AuthService,
        private route: ActivatedRoute,
        private router: Router
    ) {
        super();
    }

    ngOnInit() {
        const userId = +(this.route.snapshot.paramMap.get('userId') ?? 0);

        if (!userId) {
            this.router.navigate(['/gebruikers'], { replaceUrl: true });
            return;
        }

        this.subscriptions.add(
            this.authService.loginAsUser(userId).subscribe({
                next: token => {
                    this.subscriptions.add(
                        this.authService.switchToProfile(token.data).subscribe({
                            next: () => location.assign('/'),
                            error: () => this.router.navigate(['/gebruikers', userId], { replaceUrl: true }),
                        })
                    );
                },
                error: () => this.router.navigate(['/gebruikers', userId], { replaceUrl: true }),
            })
        );
    }
}
